import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBCarousel,
    MDBCarouselInner,
    MDBCarouselItem } from 'mdbreact';
import { MDBTable, MDBTableBody, MDBTableHead, MDBDataTable } from 'mdbreact';

import { api } from '../../api';
import Modaladdquotation from './Modaladdquotation';
import LoadingOverlay from 'react-loading-overlay';
import Modaladdquotationlist from './Modaladdquotationlist';
import Modaladdquotationlist2 from './Modaladdquotationlist2';
import Modaladdquotationlist3 from './Modaladdquotationlist3';






export default class Managehome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      emp:[],
      news:[],
      banner:[],
    };
   this.getbanner = this.getbanner.bind(this);
   this.delete = this.delete.bind(this);
   this.print = this.print.bind(this);
   
  }

  componentDidMount() {
  this.getbanner();
   
  }

  getbanner() {
    this.setState({ loading: true})
    setTimeout(() => {
       //ภายใน
       api.get('selectquotation.php')
       .then(res => {
         console.log(res);
       //  this.setState({ bankname: res.data, loading: false })
         this.setState({ banner: res.data,loading:false})
       }) 
     }, 0);
  }

  delete = (id) => { //เมื่อมีการคลิกลบ ฟังก์ชั่นนี้จะถูกเรียกใช้งาน แล้วส่ง id ที่ต้องการลบไปที่ไฟล์ delete.php
    api.get('deletequotation.php?id=' + id)
        .then((res) => {
            this.getbanner()
        })
  }

  print = (id) => { //เมื่อมีการคลิกลบ ฟังก์ชั่นนี้จะถูกเรียกใช้งาน แล้วส่ง id ที่ต้องการลบไปที่ไฟล์ delete.php
    // api.get('deletequotation.php?id=' + id)
    //     .then((res) => {
    //         this.getbanner()
    //     })
   // window.open('http://localhost/cradlebankbackend/TCPDF-main/slfrom.php?id'+id+'', '_blank');
    window.open('http://localhost/cradlebankbackend/TCPDF-main/slfrom.php?id'+id+'', '_blank');
  }


render() {
console.log(this.state.news)

const data = {
  columns: [
    {
      label: 'ลำดับ',
      field: 'list',
      sort: 'list',
      width: 150
    },
    {
        label: 'รายการ',
        field: 'PIC',
        sort: 'PIC',
        width: 200
      },
    {
      label: 'ชื่อสมาชิก',
      field: 'NAME',
      sort: 'NAME',
      width: 200
    },
     {
      label: 'เบอร์โทร',
      field: 'DATES',
      sort: 'DATES',
      width: 200
    },
    {
      label: 'ทะเบียน',
      field: 'DATESTB',
      sort: 'DATESTB',
      width: 200
    },
    {
      label: 'ยี่ห้อ',
      field: 'DATESTB1',
      sort: 'DATESTB1',
      width: 200
    },
    {
      label: 'รุ่น',
      field: 'DATESTB2',
      sort: 'DATESTB2',
      width: 200
    },
    {
      label: 'สี',
      field: 'DATESTB3',
      sort: 'DATESTB3',
      width: 200
    },
    {
      label: 'พิมพ์',
      field: 'FACULTY',
      sort: 'FACULTY',
      width: 100
    },
    {
      label: 'จัดการ',
      field: 'FACULTY2',
      sort: 'FACULTY2',
      width: 100
    }

  ],

  rows: [...this.state.banner.map((data, i) => (
    {
       list: <>{i+1}</>,
       PIC: <> ใบเสนอราคา</>,
       NAME: <>{data.gm_name}</>,
       DATES: <>{data.gm_tel}</>,
       DATESTB: <>{data.quotation_carregistration	}</>,
       DATESTB1: <>{data.carbrand_name}</>,
       DATESTB2: <>{data.carmodel_name}</>,
       DATESTB3: <>{data.quotation_carcolor}</>,
       FACULTY: <> 
      <Modaladdquotationlist quotation_id={data.quotation_id} gm_name={data.gm_name} gm_tel={data.gm_tel} quotation_carregistration={data.quotation_carregistration} carbrand_name={data.carbrand_name} carmodel_name={data.carmodel_name} quotation_carcolor={data.quotation_carcolor} />
      <Modaladdquotationlist2 quotation_id={data.quotation_id} gm_name={data.gm_name} gm_tel={data.gm_tel} quotation_carregistration={data.quotation_carregistration} carbrand_name={data.carbrand_name} carmodel_name={data.carmodel_name} quotation_carcolor={data.quotation_carcolor} />
      <Modaladdquotationlist3 quotation_id={data.quotation_id} gm_name={data.gm_name} gm_tel={data.gm_tel} quotation_carregistration={data.quotation_carregistration} carbrand_name={data.carbrand_name} carmodel_name={data.carmodel_name} quotation_carcolor={data.quotation_carcolor} />
       </>,
       FACULTY2: <> 
        <MDBBtn size="sm" color="deep-orange" onClick={() => this.delete(data.quotation_id)} >
        <MDBIcon far icon="trash-alt" /> ลบ</MDBBtn>
        </>,
      

      //  random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,

    }
   ))] 

};

const persons = <MDBDataTable
// searching ={true}
searchLabel="ค้นหา รายการ"
striped
bordered
small 
entries={20}
// entriesOptions={["10", "20"]}
order={["age", "desc"]}
data={data}
entriesLabel="จำนวนที่แสดง "
infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
paginationLabel={["ย้อนกลับ", "ถัดไป"]}
responsive 
sortRows={['random']}
/>

return (
  <LoadingOverlay
  active={this.state.loading}
  spinner
  text='Loading your data...'
  >
  <MDBContainer fluid>
    <br/>
    <h2 className='text-center mt-2'>ระบบจัดการ รายการซ่อม</h2>
    <h4 className='text-center'>ผู้ใช้งาน : {localStorage.getItem('name_member')}</h4>
  <p className='text-center'><Modaladdquotation getbanner={this.getbanner}/></p> 
  <h2 className='text-left'>รายการใบเสนอราคา</h2>
     {persons}
  </MDBContainer>
  </LoadingOverlay>  
)
}
}